// Max and Max Heart Rate from the data array
/**
 * Finds the lowest and highest heart rate reached across the study's daily summaries. Reduces from positive and negative infinity, skips days lacking either value, and keeps the date, value, time and one-based day number of each extreme.
 *
 * @param data - The study's daily HR summaries, in chronological order.
 * @returns An object carrying minHr and maxHr, each with its date, value, time and days.
 */
export const getMinMaxHr = (data: any[]) =>
  data.reduce(
    (acc: any, entry: any, index: number) => {
      // Check if the MinhR value is less than the current value in the accumulator
      if (entry.minHr && entry.maxHr) {
        if (entry.minHr.value < acc.minHr.value) {
          acc.minHr = {
            date: entry.date,
            value: entry.minHr.value,
            time: entry.minHr.time,
            days: index + 1,
          };
        }
        // Check if the value of the mextl is greater than the current value in the accumulator
        if (entry.maxHr.value > acc.maxHr.value) {
          acc.maxHr = {
            date: entry.date,
            value: entry.maxHr.value,
            time: entry.maxHr.time,
            days: index + 1,
          };
        }
        return acc;
      }
      return acc;
    },
    // The initial value for Minhr and Maxhr.
    {
      minHr: {
        value: Infinity,
        date: null,
        time: null,
        days: 0,
      },
      maxHr: {
        value: -Infinity,
        date: null,
        time: null,
        days: 0,
      },
    },
  );

// This function is used to sort the min and max hr data HRS
/**
 * Orders the candidate min or max heart rate entries offered in the HR picker. Sorts in place with user-updated entries first, then by value ascending for minHrs and descending for maxHrs, and finally by start time ascending.
 *
 * @param data - Candidate heart rate entries with value, start and userUpdated.
 * @param type - Which list is being sorted, minHrs or maxHrs; minHrs by default.
 * @returns The same array, sorted in place.
 */
export const sortMinMaxHr = (data: any[], type = 'minHrs') => {
  data.sort((a: any, b: any) => {
    // Ưu tiên userUpdated
    if (a.userUpdated && !b.userUpdated) {
      return -1;
    }
    if (!a.userUpdated && b.userUpdated) {
      return 1;
    }

    // Nếu userUpdated giống nhau, sắp xếp theo value
    if (a.value !== b.value) {
      if (type === 'minHrs') {
        return a.value - b.value; // Tăng dần (minHrs)
      }
      if (type === 'maxHrs') {
        return b.value - a.value; // Giảm dần (maxHrs)
      }
    }

    // Nếu value giống nhau, sắp xếp theo start (tăng dần)
    const startA = new Date(a.start).getTime();
    const startB = new Date(b.start).getTime();
    return startA - startB;
  });
  return data;
};
